// import GetAppHost from '../utils/GetAppHost';
import RealTimeMessagesReceiver from './RealTimeMessagesReceiver';
import Api from '../utils/Api';

let arkiaHub = null;
const $ = window.$;
const abp = window.abp;

const SignalR = {

  start: (encryptedToken) => {

    // 🔹 Evitar múltiples conexiones (SIN optional chaining)
    if (
      arkiaHub &&
      arkiaHub.connection &&
      arkiaHub.connection.connectionState === 1
    ) {
      return;
    }

    let url = Api.getHost() + '/signalr';
    const token =
      encryptedToken || window.localStorage.getItem('encryptedAccessToken');

    // 🔐 Token por query (Safari OK)
    if (token) {
      url += '?enc_auth_token=' + encodeURIComponent(token);
    }

    if (!abp || !abp.signalr) {
      console.error('ABP SignalR no disponible');
      return;
    }

    $(function () {

      abp.signalr.startConnection(
        url,
        function (connection) {
          arkiaHub = connection;

          console.log('✅ SignalR conectado');

          connection.on('getMessage', function (message) {
            RealTimeMessagesReceiver(message);
          });

          connection.on('getNotification', function (message) {
            RealTimeMessagesReceiver(message);
          });

          // 🔹 Registrar usuario al conectar
          if (window.localStorage) {
            const user = window.localStorage.getItem('user');
            if (user) {
              SignalR.register(JSON.parse(user).id);
            }
          }
        },
        {
          transport: ['webSockets'] // 🔥 NUNCA longPolling
        }
      );
    });
  },

  close: function () {
    try {
      if (arkiaHub) {
        arkiaHub.stop();
        arkiaHub = null;
      }

      if (abp && abp.signalr && abp.signalr.hubs && abp.signalr.hubs.common) {
        abp.signalr.hubs.common.stop();
      }
    } catch (e) {
      console.warn('Error cerrando SignalR', e);
    }
  },

  isConnected: function () {
    return (
      arkiaHub &&
      arkiaHub.connection &&
      arkiaHub.connection.connectionState === 1
    );
  },

  invoke: function (message, type) {
    type = type || 'sendMessage';

    if (!SignalR.isConnected()) {
      console.warn('⚠️ SignalR no conectado');
      return;
    }

    arkiaHub.invoke(type, message);
  },

  register: function (userId) {
    SignalR.invoke(
      {
        userId: userId,
        url: window.location.pathname
      },
      'register'
    );
  },

  unRegister: function (userId) {
    SignalR.invoke({ userId: userId }, 'unregister');
  }
};

export default SignalR;
